import { ElementVisibility } from '~/src/common/appearence/ElementVisibility';

const lohPathnameRegExp = /^\/(es\/)?(\?[^\/]*)?$/i;
const createAccountPathnameRegExp = /^\/?(es\/)?create-account\//i;
const billingPathnameRegExp = /^\/?(es\/)?billing\//i;
const choosePlanPathnameRegExp = /^\/?(es\/)?choose-plan\//i;
const playerPathnameRegExp = /^\/?(es\/)?ecourse\/player\//i;
const urlPathnameSearchButtonShownBlacklist = [
  lohPathnameRegExp,
  createAccountPathnameRegExp,
  billingPathnameRegExp,
  choosePlanPathnameRegExp,
  playerPathnameRegExp,
];

export function getGlobalSearchButtonVisibility({
  isLoggedIn,
  isSSR,
  isUserDetailsLoading,
  pathname,
}: {
  isSSR: boolean;
  isUserDetailsLoading: boolean;
  isLoggedIn: boolean;
  pathname: string;
}): ElementVisibility {
  const userStatus =
    isUserDetailsLoading || isSSR ? 'loading' : isLoggedIn ? 'authorized' : 'unauthorized';
  if (userStatus === 'loading') {
    return { isShown: false };
  }

  if (userStatus === 'authorized') {
    return { isShown: true };
  }

  const isInBlackList = urlPathnameSearchButtonShownBlacklist.some(re => re.test(pathname));

  return { isShown: !isInBlackList };
}
